export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    showPX: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputNumber: 0
    };
  },
  watch: {
    size: {
      handler(val) {
        this.inputChange(val);
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.inputNumber = this.size;
      this.$emit('input', this.size);
    });
  },
  methods: {
    inputChange(val) {
      this.inputNumber = val;
      this.$emit('input', val);
    }
  },
  updated() {
    this.inputNumber = this.size;
  }
};